import { Scrollbars } from 'react-custom-scrollbars'

export default function CustomScrollbars({ children }: any) {
  return (
    <Scrollbars
      renderThumbHorizontal={() => (
        <div className="bg-brij-Mud rounded-md opacity-30" />
      )}
      renderThumbVertical={() => (
        <div className="bg-brij-Mud rounded-md opacity-30" />
      )}
    >
      {children}
    </Scrollbars>
  )
}
